import {CLIENT_LOGOUTURL } from "../Constants/config";

export const handleApiError = (data) => {
    if((data?.response?.status === 'error' && data?.response?.code === 401) || 
        (data?.status === 'error' && data?.code === 401)) {
        localStorage.removeItem("tokenVerification");
        localStorage.removeItem("userVerificationCandidate");
        let userData = JSON.parse(localStorage.getItem('autoLogin'));
        if(userData?.data?.user_role == "EP"){
            window.location.href = CLIENT_LOGOUTURL;
        }else{
            window.location = "login";
        }
      }
  };